export const Locales = {
    En: "en",
    Ru: "ru",
    Es: "es",
    Ua: "ua"
}
